import { Loader } from '@googlemaps/js-api-loader';

let loader: Loader;
export let places: google.maps.PlacesLibrary;
export let geocodingLibrary: google.maps.GeocodingLibrary;
export let geocoder: google.maps.Geocoder;
export let maps: google.maps.MapsLibrary;
export let markers: google.maps.MarkerLibrary;

export async function InitGoogleLibraries() {
  console.log('INITIALIZING GOOGLE LIBRARIES');
  if (!loader) {
    loader = new Loader({ apiKey: import.meta.env.VITE_MAPS_API_KEY, version: 'weekly' });
  }
  places = await loader.importLibrary('places');
  geocodingLibrary = await loader.importLibrary('geocoding');
  geocoder = new geocodingLibrary.Geocoder();
  maps = await loader.importLibrary('maps');
  markers = await loader.importLibrary('marker');
  console.log('GOOGLE LIBRARIES INITIALIZED');
}
